/**
 * Warenkorb Redesign: Kategorie-Chips im Upsell.
 * Das Markup wird von Liquid Ajax Cart neu gerendert, darum per Event-Delegation
 * und mit gemerktem Tab, der nach jedem Request wieder gesetzt wird.
 */
(function () {
  if (window.dsCartRedesignInit) return;
  window.dsCartRedesignInit = true;

  var activeTab = '0';

  function applyTab(root, index) {
    var tabs = root.querySelectorAll('[data-rd-upsell-tab]');
    if (!tabs.length) return;
    var exists = root.querySelector('[data-rd-upsell-panel="' + index + '"]');
    if (!exists) index = '0';

    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-rd-upsell-tab') === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });
    root.querySelectorAll('[data-rd-upsell-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-rd-upsell-panel') !== index;
    });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-rd-upsell-tab]');
    if (!tab) return;
    var root = tab.closest('[data-rd-upsell]');
    if (!root) return;
    activeTab = tab.getAttribute('data-rd-upsell-tab');
    applyTab(root, activeTab);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest('[data-rd-upsell-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    var root = tab.closest('[data-rd-upsell]');
    if (!root) return;
    var tabs = Array.from(root.querySelectorAll('[data-rd-upsell-tab]'));
    var index = tabs.indexOf(tab);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = tabs.length - 1;
    else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    activeTab = tabs[index].getAttribute('data-rd-upsell-tab');
    applyTab(root, activeTab);
    tabs[index].focus();
  });

  /**
   * Der aktive Code steht als Cart-Attribut fest, auch wenn Shopify ihn nicht anwenden kann
   * (z. B. Mindestbestellwert nicht erreicht). Liquid kennt "applicable" nicht, darum wird
   * die Bestätigung hier ausgeblendet und das Eingabefeld bleibt sichtbar.
   */
  function applyDiscountState(discountCodes) {
    document.querySelectorAll('[data-rd-discount-code]').forEach(function (box) {
      var code = box.getAttribute('data-rd-discount-code').toLowerCase();
      var invalid = discountCodes.some(function (entry) {
        return entry.code.toLowerCase() === code && entry.applicable === false;
      });
      box.hidden = invalid;
      var success = box.parentNode.querySelector('[data-rd-discount-success]');
      if (success) success.hidden = invalid;
    });
  }

  // Die Antworten von /cart/update.js enthalten keine discount_codes, darum bei Bedarf /cart.js
  function syncDiscount() {
    if (!document.querySelector('[data-rd-discount-code]')) return;
    var cart = window.liquidAjaxCart && window.liquidAjaxCart.cart;
    if (cart && cart.discount_codes) {
      applyDiscountState(cart.discount_codes);
      return;
    }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (data) { applyDiscountState(data.discount_codes || []); })
      .catch(function () {});
  }

  /**
   * Voraussichtliche Lieferung, gleiche Regel wie der Versand-Tracker der Produktseite:
   * Bestelltag (nach Bestellschluss der Folgetag) → Backtag aus der Versandtabelle →
   * die zwei folgenden Tage ohne Sonntag.
   */
  function berlinToday() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      weekday: 'short',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      hourCycle: 'h23'
    }).formatToParts(new Date());
    var map = {};
    parts.forEach(function (p) { map[p.type] = p.value; });
    var weekdays = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
    return {
      day: weekdays[map.weekday] || 1,
      hour: parseInt(map.hour, 10) || 0,
      date: Date.UTC(parseInt(map.year, 10), parseInt(map.month, 10) - 1, parseInt(map.day, 10))
    };
  }

  function nextDay(day) {
    return day % 7 + 1;
  }

  function updateDelivery() {
    document.querySelectorAll('[data-rd-delivery]').forEach(function (row) {
      var shipMap = (row.dataset.shipMap || '').split(',').map(function (n) { return parseInt(n, 10); });
      var daysShort = (row.dataset.daysShort || '').split(',');
      var cutoff = parseInt(row.dataset.cutoff, 10) || 16;
      var valueEl = row.querySelector('[data-rd-delivery-value]');
      if (shipMap.length !== 7 || daysShort.length !== 7 || !valueEl) return;

      var now = berlinToday();
      var late = now.hour >= cutoff;
      var orderDay = late ? nextDay(now.day) : now.day;
      var bakeDay = shipMap[orderDay - 1];
      if (!bakeDay || bakeDay < 1 || bakeDay > 7) return;

      var offset = (late ? 1 : 0) + ((bakeDay - orderDay + 7) % 7 || 7);
      var d = bakeDay;
      var parts = [];
      while (parts.length < 2) {
        d = nextDay(d);
        offset += 1;
        if (d !== 7) {
          var date = new Date(now.date + offset * 86400000);
          parts.push(daysShort[d - 1] + ' ' + date.getUTCDate() + '.' + (date.getUTCMonth() + 1) + '.');
        }
      }
      valueEl.textContent = parts.join(' / ');
      row.hidden = false;
    });
  }

  document.addEventListener('liquid-ajax-cart:request-end', function () {
    document.querySelectorAll('[data-rd-upsell]').forEach(function (root) {
      applyTab(root, activeTab);
    });
    syncDiscount();
    updateDelivery();
  });

  function init() {
    syncDiscount();
    updateDelivery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('liquid-ajax-cart:init', init);
})();
